export default "__VITE_ASSET__80f6fe2d__"